module.exports = __webpack_public_path__ + "static/media/logos_squares_Diamond_ANLEV.c506b366.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Diamond_ANLEV.png
// module id = 76
// module chunks = 0